import "./components/components.js";
import "./controllers/controllers.js";

import "./recipal-app.scss";

import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
